import { render } from "./uploadfileView.vue?vue&type=template&id=3e9c836c&ts=true"
import script from "./uploadfileView.vue?vue&type=script&lang=ts"
export * from "./uploadfileView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__